import { TFilterItem } from 'components/rest/Filter/FilterRow';
import RestList from 'containers/rest/List';
import { IRestColumnProps } from 'components/rest/Table/TableColumn';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import { formatDateTime } from 'utils/formattedString';

const SEARCH_KEYS = ['locationCode', 'variantSku'];

const breadcrumbs = [
  {
    title: 'common.page.settings',
    href: '/settings',
  },
  {
    title: 'common.page.locations',
  },
];

const filters: TFilterItem[] = [
  {
    key: 'createdAt',
    label: 'Created time',
    isDatePicker: true,
  },
  {
    key: 'updatedAt',
    label: 'Updated time',
    isDatePicker: true,
  },
  {
    key: 'locationCode',
    label: 'Location Code',
  },
  {
    key: 'variantSku',
    label: 'Variant SKU',
  },
];

const initialFilter = {
  join: ['detail'],
};

export default function LocationsList() {
  const { t } = useTranslation();
  const importModalRef = useRef(null);
  const columns: IRestColumnProps[] = [
    {
      name: 'createdAt',
      title: 'Created Time',
      render: (data: string) => <span>{formatDateTime(data)}</span>,
      isDefault: true,
      width: 300,
      ellipsis: true,
    },
    {
      name: 'updatedAt',
      title: 'Updated Time',
      render: (data: string) => <span>{formatDateTime(data)}</span>,
      isDefault: true,
      width: 200,
      ellipsis: true,
    },
    {
      name: 'locationCode',
      title: 'locationCode',
      isDefault: true,
      width: 200,
      ellipsis: true,
    },
    {
      name: 'variantSku',
      title: 'variantSku',
      isDefault: true,
      width: 120,
      ellipsis: true,
    },
    {
      name: 'stockOriginal',
      title: 'stockOriginal',
      isDefault: true,
      width: 200,
      ellipsis: true,
    },
    {
      name: 'stockOriginalPrev',
      title: 'stockOriginalPrev',
      isDefault: true,
      width: 120,
      ellipsis: true,
    },
  ];
  return (
    <div className="location-listing">
      <RestList
        filters={filters}
        initialFilter={initialFilter}
        columns={columns}
        breadcrumbs={breadcrumbs}
        model="locationStockChanges"
        rowSelectionActions={<></>}
        // formatListData={formatListData}
        searchKeys={SEARCH_KEYS}
        placeholderInputSearch={t('mores.locations.searchPlaceholder')}
        className=""
        hasImportV2={false}
        hasImport={false}
        hasExport={false}
        openModalImport={() => importModalRef.current.openModal()}
      />
    </div>
  );
}
